import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";

const TimesheetTotals = ({ rows, dates }) => {
  const week = useMemo(
    () =>
      rows.reduce((acc, curr) => {
        curr.calls.forEach((call) => {
          acc[call.day] = acc[call.day]
            ? Number(acc[call.day]) +
              Number(call.actual_hrs ? call.actual_hrs : 0)
            : call.actual_hrs;
        });
        return acc;
      }, {}),
    [rows]
  );
  const columns = [
    ...dates.map((date, i) => (
      <span key={i}>
        <p>{Number(week[date.day] || 0).toFixed(1)}</p>
      </span>
    )),
    <span key="weekly-totals">
      <p>
        {rows
          .reduce(
            (total, row, i) =>
              total +
              (typeof row[`total ${i}`] === "number" ? row[`total ${i}`] : 0),
            0
          )
          .toFixed(1)}
      </p>
    </span>
  ];

  return (
    <Row className="time-total">
      <Col md={6} mdOffset={6}>
        {columns}
      </Col>
    </Row>
  );
};

TimesheetTotals.propTypes = {
  rows: PropTypes.array,
  dates: PropTypes.array
};
export default TimesheetTotals;
